import request from '@/utils/request'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

/* *** 项目相关接口 *** */
// 查询评审项目信息
export function getReviewProjectApi(projectId) {
  return request({
    url: purchaseApi + `/review-hall/purchaser/kpb/projects/${projectId}`,
    method: 'get'
  })
}

// 下载招标文件
export function downloadBidFileApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/down-bidding-file`,
    method: 'get',
    params
  })
}

// 获取评审进度
export function getReviewProcessApi(projectId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes`,
    method: 'get'
  })
}

/* *** 组长相关接口 *** */
// 查询专家组长推荐结果列表
export function getReviewerListApi(projectId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/reviewers`,
      method: 'get'
    },
    false
  )
}

/* *** 评审环节相关接口 *** */
// 查询评审办法以及评审状态的列表
export function getReviewTaskSummaryListApi(projectId, processId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/way-summaries`,
      method: 'get'
    },
    false
  )
}

// 查询各评审办法下的汇总信息
export function getReviewWaySummaryApi(
  projectId,
  processId,
  reviewWayId,
  params
) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-ways/${reviewWayId}/reviewers/summary`,
    method: 'get',
    params
  })
}

// 评标结束-汇总结果
export function getEndReviewSummaryApi(projectId, processId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-summary/page`,
    method: 'get',
    params
  })
}

// 评标结束-最低价/最高价汇总结果
export function getEndReviewByQuoteSummaryApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/v2/${projectId}/offer-open/review-summary`,
    method: 'get',
    params
  })
}

// 查询废标记录
export function getWithdrawBidderListApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/bidder-waste/page`,
    method: 'get',
    params
  })
}

/* *** 专家询标相关接口 *** */
// 分页查询询标-投标人列表
export function getInquiryBidderListApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/bidder-asks`,
    method: 'get',
    params
  })
}

// 分页查询询标-消息列表
export function getInquiryBidderMessageListApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/review-asks/page`,
      methods: 'get',
      params
    },
    false
  )
}

/* *** 废标相关接口 *** */
// 分页查询废标记录
export function getWithdrawBidderHistoryApi(projectId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/bidder-waste/page`,
    method: 'get',
    params
  })
}

/* *** 评标报告相关接口 *** */
// 查询评标报告表
export function getReviewReportApi(projectId, processId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/last`,
    method: 'get'
  })
}

// 查询评标报告下的目录列表
export function getReviewReportCatalogListApi(
  projectId,
  processId,
  reportId,
  params
) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/catalogs`,
    method: 'get',
    params
  })
}

// 按投标人汇总汇总结果
export function getReviewReportResultApi(projectId, params = {}) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/bidders/summary-result`,
      method: 'get',
      params
    },
    false
  )
}

// 评标报告(报告正文内容)
export function getReviewReportWordApi(projectId, processId, reportId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/word`,
      method: 'get'
    },
    false
  )
}

// 评标报告-综合评分排序表
export function getReviewReportSummaryListApi(projectId, processId, reportId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/rating-rank`,
      method: 'get'
    },
    false
  )
}

// 评标报告-开标一览表
export function getReviewReportMarkListApi(projectId, processId, reportId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/bidder-mark`,
      method: 'get'
    },
    false
  )
}

// 评标报告-每个评审办法汇总表
export function getReviewReportReviewWayListApi(
  projectId,
  processId,
  reportId,
  params
) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/final-score`,
      method: 'get',
      params
    },
    false
  )
}

// 评标报告-每个评审办法的评审点汇总表
export function getReviewReportReviewWayPointListApi(projectId, reviewWayId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/review-way/${reviewWayId}/review-way-item/reviewer-score`
    },
    false
  )
}

// 评标报告-每个专家打分表
export function getReviewReportReviewerListApi(
  projectId,
  processId,
  reportId,
  params
) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/reviewer-score`,
      method: 'get',
      params
    },
    false
  )
}

// 评标报告-评审询标记录表
export function getReviewReportAskListApi(projectId, processId, reportId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/review-asks`,
      method: 'get'
    },
    false
  )
}

// 查询询标-投标人列表
export function getReviewReportBidderListApi(projectId, params) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/bidder-asks`,
      method: 'get',
      params
    },
    false
  )
}

// 评标报告 - 投标单位多轮报价
export function getReviewReportOfferListApi(projectId, processId, reportId) {
  return request(
    {
      url: `${purchaseApi}/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/bidder-round-offer`,
      method: 'get'
    },
    false
  )
}

// PDF附件并上传（附件id）
export function uploadReviewReportFileApi(
  projectId,
  processId,
  reportId,
  catalogId,
  data
) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/catalogs/${catalogId}/upload`,
      method: 'post',
      data
    },
    false
  )
}

// 附件上传完成
export function completeUploadReviewReportFileApi(
  projectId,
  processId,
  reportId
) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/upload-complete`,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    },
    false
  )
}

// 下载报告目录附件
export function downloadReviewReportCatalogApi(
  projectId,
  processId,
  reportId,
  catalogId
) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/catalogs/${catalogId}/down`,
      method: 'get'
    },
    false
  )
}

// 查询开评标专家签名信息
export function getReviewerSignListApi(projectId, processId, reportId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/reviewer-signs`,
    method: 'get'
  })
}

// 评标报告完成签名报告上传
export function completeUploadSignReportFileApi(
  projectId,
  processId,
  reportId
) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/sign-complete`,
    method: 'post'
  })
}

// 保存评标报告正文编辑后的内容
export function saveReviewReportWordApi(projectId, processId, reportId, data) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/reports/${reportId}/update-content`,
    method: 'post',
    data
  })
}

// 获取评审专家任务汇总
export function getReviewWayExpertTaskListApi(
  projectId,
  processId,
  reviewWayId
) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-way/${reviewWayId}/reviewers/task-summary`,
    method: 'get'
  })
}

// 查询专家打分明细
export function getReviewWayScoreApi(
  projectId,
  processId,
  reviewWayId,
  reviewerId,
  params
) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-way/${reviewWayId}/reviewers/${reviewerId}/summary`,
    method: 'get',
    params
  })
}

// 查询企业折扣率列表
export function getReviewQuotaRatesApi(projectId, processId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-offer/bidder-rates`,
    method: 'get'
  })
}

// 查询评审报价轮次列表
export function getReviewRoundListApi(projectId, processId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-offer/offer-rounds`,
    method: 'get'
  })
}

// 分页查询投标人多轮报价列表
export function getReviewRoundQuotaPageApi(projectId, processId, params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${projectId}/processes/${processId}/review-offer/round-offers/page`,
    method: 'get',
    params
  })
}

// 查询企业折扣率列表
export function getBidderQuoteRateListApi(projectId, processId, offerId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/expert/kpb/projects/${projectId}/processes/${processId}/review-offer/${offerId}/bidder-rates`,
      method: 'get'
    },
    false
  )
}

// 专家的打分表统计信息
export function getReviewBidderStatisticsApi(projectId, processId, wayTaskId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/expert/kpb/projects/${projectId}/processes/${processId}/way-tasks/${wayTaskId}/score-summary`,
      method: 'get'
    },
    false
  )
}

// 分页查询专家打分表
export function getReviewTaskBidderListApi(projectId, reviewWayId) {
  return request(
    {
      url:
        purchaseApi +
        `/review-hall/purchaser/kpb/projects/${projectId}/review-ways/${reviewWayId}/bidders`
    },
    false
  )
}

// 预览投标单位的报价文件
export function previewReviewBidderOfferFileApi(params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${params.projectId}/preview-offer-file`,
    method: 'get',
    params
  })
}

// 下载投标单位的报价文件
export function downloadReviewBidderOfferFileApi(params) {
  return request({
    url:
      purchaseApi +
      `/review-hall/purchaser/kpb/projects/${params.projectId}/down-offer-file`,
    method: 'get',
    params
  })
}
